export default __webpack_public_path__ + "static/media/Referidos-320x50.23e2a682.jpg";